import {COLORS, SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const NotificationCenterSkeletons = () => {
  return (
    <Wrapper>
      {Array.from({length: 4}).map((_, index) => (
        <StyledSkeletonBlock key={index} $width="100%" />
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  padding: 16px;
  background-color: ${COLORS['Fill.Grey.Primary']};
`;

const StyledSkeletonBlock = styled(SkeletonBlock)`
  min-height: 140px;
`;
